import cmp from './LandingPage'

export default cmp
